import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en.json';
import es from './locales/es.json';
import de from './locales/de.json';
import ru from './locales/ru.json';
import zh from './locales/zh.json';
import ar from './locales/ar.json';
import fr from './locales/fr.json';
import pt from './locales/pt.json';

const resources = {
  en: { translation: en },
  es: { translation: es },
  de: { translation: de },
  ru: { translation: ru },
  zh: { translation: zh },
  ar: { translation: ar },
  fr: { translation: fr },
  pt: { translation: pt },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // If system/browser language is not supported, fall back to English.
    fallbackLng: 'en',
    // Only allow languages we actually ship.
    supportedLngs: Object.keys(resources),
    // Treat 'de-DE' as 'de' (same for other regional variants).
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage'],
      lookupLocalStorage: 'salesign-language',
      checkWhitelist: true,
      // Normalize detected codes like 'de-DE' -> 'de'
      convertDetectedLanguage: (lng) => (lng || 'en').split('-')[0],
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;





